export enum QuestionTypes {
  MULTIPLE_CHOICE = "Multiple Choice",
  MULTIPLE_CHOOSE = "Multiple Choose",
  SHORT_ANSWER = "Short Answer",
}

export const QuestionTypesHelper = {
  fromValue: function (e: string): QuestionTypes | undefined {
    switch (e) {
      case "Multiple Choice":
        return QuestionTypes.MULTIPLE_CHOICE;
      case "Multiple Choose":
        return QuestionTypes.MULTIPLE_CHOOSE;
      case "Short Answer":
        return QuestionTypes.SHORT_ANSWER;
    }
  },
};
